// extracted by mini-css-extract-plugin
export default {"textoDireccion":"MapLeaflet_textoDireccion__124lG"};